export function initialiseDialogs() {
	document.querySelectorAll<HTMLDialogElement>('dialog.website-dialog').forEach(dialog => {
		dialog.addEventListener(
			'keydown',
			event => {
				if (event.key !== 'Escape') return;
				const target = event.target instanceof Element ? event.target : null;
				if (dialog.querySelector('[role="dialog"], [role="listbox"]') || target?.getAttribute('aria-expanded') === 'true') {
					event.preventDefault();
				}
			},
			true
		);
		dialog.querySelectorAll<HTMLButtonElement>('[data-dialog-close]').forEach(button => {
			button.addEventListener('click', () => dialog.close());
		});
		dialog.addEventListener('click', event => {
			if (event.target === dialog) dialog.close();
		});
		if (dialog.hasAttribute('data-page-dialog') && window.matchMedia('(min-width: 768px)').matches) {
			dialog.showModal();
			const delay = Number(dialog.dataset.pageDialog);
			if (delay > 0) {
				const timer = window.setTimeout(() => dialog.close(), delay);
				dialog.addEventListener('close', () => window.clearTimeout(timer), { once: true });
			}
		}
	});
	document.querySelectorAll<HTMLButtonElement>('[data-dialog-open]').forEach(button => {
		button.addEventListener('click', () => {
			const dialog = document.getElementById(button.dataset.dialogOpen ?? '');
			if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
		});
	});
}
